import { Button, Typography } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
//import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { getCopyName } from "../../libs/getCopyName";
import { debounce } from "lodash";
import Moment from "moment";
import React from "react";
import loaderimage from "../../assets/images/PageLoader.svg";
import "../../assets/scss/all-estimates.scss";
import fire from "../../config/firebase";
import NoItemAddedEstimate from "./NoItemAddedEstimate";
import AlertDialog from "../small-components/AlertDialog/AlertDialog";
import FilterBox from "../small-components/FilterBox";
import FilterList from "../small-components/FilterList";
// import NoContent from '../small-components/nocontent';
import PaginationList from "../small-components/pagination";
import EstimateFor from "../reusable-components/EstimateFor";
import SettingsTable from "../small-components/SettingTemplate/SettingTemplate";
import { withRouter } from "react-router-dom";
class AllEstimates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      age: "",
      key: "",
      typeCast: "",
      arrayItem: [],

      page: 1,
      editList: [
        {
          type: "Edit",
          icon: <CreateIcon htmlColor="#000000" fontSize="small" />,
          id: "edit",
        },
        {
          type: "Save As Template",
          icon: <InsertDriveFileIcon htmlColor="#000000" fontSize="small" />,
          id: "SaveTemplate",
        },
        {
          type: "Duplicate",
          icon: <FileCopyIcon htmlColor="#000000" fontSize="small" />,
          id: "duplicate",
        },
        {
          type: "Delete",
          icon: <DeleteIcon htmlColor="#000000" fontSize="small" />,
          id: "delete",
        },
      ],
      listToShow: [],
      sort: "recent",
      itemKey: "",
      deleteId: "",
      favoriteValue: "",
      dialogOpen: false,
      drawerState: false,
      optionAction: "",
      uniqueId: "",
      loader: true,
      currentUser: "",
      userEmail: "",
      userName: "",
      users: [],
      favoriteestimate: [],
      searchKey: "",
      defaultSearchValue: "",
      allTags: [],
    };
    //this.items = [...this.state.EstimateItem];
    this.paginationCount = 6;
    this.refreshData = this.refreshData.bind(this);
  }
  refreshData() {
    if (this.props.update) {
      this.props.update();
    }
    const undoData = [];
    localStorage.setItem("undoData", JSON.stringify(undoData));

    const reftagList = fire.database().ref("tags");
    reftagList.once("value").then((snapshot) => {
      const tags = snapshot.val();
      reftagList.off("value");
      const allTags = [];
      for (const id in tags) {
        allTags.push({ id, ...tags[id] });
      }
      this.setState({ allTags });
    });

    const ref = fire.database().ref("estimates");
    ref.once("value").then(
      (snapshot) => {
        const estimates = snapshot.val();
        ref.off("value");
        let estimateList = [];
        for (const id in estimates) {
          if (estimates[id].tags === undefined) {
            estimates[id].tags = [];
          }
          estimateList.unshift({ id, ...estimates[id] });
        }
        estimateList = estimateList.filter(
          (d) => d.archive !== "true" && d.projectName
        );
        this.items = estimateList;
        this.setState({ arrayItem: estimateList, loader: false });
        // setTimeout(() => {
        //   const key = localStorage.getItem("key");
        //   const database = localStorage.getItem("editDatabase");
        //   if (key && database === "estimates") {
        //     this.optionChange("Edit", key);
        //     localStorage.setItem("editDatabase", "");
        //   }
        // }, 500);
      },
      (error) => {
        console.log("Error: " + error.code);
      }
    );
    //users
    const userListRef = fire.database().ref("users");
    userListRef.once("value").then((snapshot) => {
      const users = snapshot.val();
      userListRef.off("value");
      const userlist = [];
      for (const id in users) {
        userlist.push({ id, database: "users", ...users[id] });
      }
      this.setState({ users: userlist });
    });
    //Current User

    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          currentUser: user,
          userEmail: user.email,
          userName: user.displayName,
        });
      }
    });

    const searchORG = localStorage.getItem("searchText");
    if (searchORG) {
      this.setState({
        defaultSearchValue: searchORG,
        searchKey: searchORG,
      });
    }
    setTimeout(() => {
      localStorage.setItem("searchText", "");
    }, 500);
  }

  componentDidMount = () => {
    this.refreshData();
  };

  closeHandler = () => {
    this.setState({ dialogOpen: false });
  };
  handleSort = (e) => {
    this.setState({ sort: e });
  };
  handleFavorite = (id) => {
    for (let i = 0; i < this.state.users.length; i++) {
      if (this.state.users[i]["caption"] === this.state.userEmail) {
        const userID = this.state.users[i]["id"];
        let favoriteestimate = [];
        if (this.state.users[i]["favoriteestimate"]) {
          favoriteestimate = this.state.users[i]["favoriteestimate"];
        }
        let recentExist = 0;
        let recentExistIndex = 0;
        this.setState({ favoriteestimate: favoriteestimate });
        if (this.state.users[i]["favoriteestimate"]) {
          favoriteestimate = this.state.users[i]["favoriteestimate"];
          for (let k = 0; k < favoriteestimate.length; k++) {
            if (favoriteestimate[k]) {
              if (id === favoriteestimate[k]["id"]) {
                recentExist = 1;
                recentExistIndex = k;
              }
            }
          }
        }
        if (recentExist === 1) {
          favoriteestimate.splice(recentExistIndex, 1);
          const userRef = fire.database().ref("users").child(userID);
          userRef.update({
            favoriteestimate: favoriteestimate,
          });
        }
        if (recentExist === 0) {
          favoriteestimate.unshift({ id });

          const userRef = fire.database().ref("users").child(userID);
          userRef.update({
            favoriteestimate: favoriteestimate,
          });
        }
      }
    }
    this.refreshData();
  };

  handlePages = (key) => {
    const val = key.toLowerCase().split(" ").join("-");
    if (val === "time-based")
      this.setState({
        typeCast: true,
      });
    else
      this.setState({
        typeCast: true,
      });
  };
  inputText = debounce((e) => {
    this.setState({
      key: e,
      page: 1,
    });
  }, 700);
  handleChange = (event) => {
    this.setState({
      age: event.target.value,
      page: 1,
    });
  };
  handlePageChange = (event, value) => {
    this.setState({
      page: value,
    });
  };

  overlay = (e) => {
    e.preventDefault();
    document.querySelector(".overlay").classList.add("activeOverlay");
  };
  optionChange = debounce((value, itemIndex) => {
    if (value === "Delete") {
      this.setState({
        dialogOpen: true,
        phaseKey: itemIndex,
        optionAction: value,
        drawerState: false,
      });
    } else if (value === "Duplicate") {
      let flag = 0;
      let projectName = "",
        copy = "";
      for (let i = 0; i < this.state.arrayItem.length; i++) {
        if (this.state.arrayItem[i]["id"] === itemIndex) {
          if (flag === 0) {
            flag = 1;
            copy = this.state.arrayItem[i];
            projectName = this.state.arrayItem[i]["projectName"];
            copy.id = null;
            copy.projectName = getCopyName(projectName, this.state.arrayItem, 'projectName');
            copy.date = Moment(new Date()).format("DD/MM/YYYY");
            copy.timestamp = Math.floor(Date.now() / 1000);
            copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");
            const estimateRef = fire.database().ref("estimates");
            estimateRef.push(copy);
          }
        }
      }
    } else if (value === "Edit") {
      const item = this.items.find((d) => d.id === itemIndex);
      if (item) {
        this.setState(
          {
            phaseKey: itemIndex,
            optionAction: value,
            drawerState: true,
            drawerType: "old",
            drawerDefaultName: item["title"],
            drawerDefaultColor: item["borderColor"],
            typeCast: true,
          },
          () => {
            let temptype = "";
            if (item.typeOf === "TIME BASED ESTIMATE") {
              temptype = "-timebased";
            }
            this.props.history.push(
              `/estimates${temptype}/` + item.projectName + "/" + item["id"]
            );
          }
        );
      }

      setTimeout(() => {
        this.setState({
          optionAction: "",
        });
      }, 1000);
    } else if (value === "Save") {
      let copy = "";
      for (let i = 0; i < this.state.arrayItem.length; i++) {
        if (this.state.arrayItem[i]["id"] === itemIndex) {
          copy = this.state.arrayItem[i];
          copy.id = null;
          copy.date = Moment(new Date()).format("DD/MM/YYYY");
          copy.timestamp = Math.floor(Date.now() / 1000);
          copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");

          const templatesRef = fire.database().ref("templates");
          templatesRef.push(copy);

          // const estimateRef = fire.database().ref('estimates').child(itemIndex);
          // estimateRef.remove();
        }
      }
    }
    this.refreshData();
  });
  drawerDelete = () => {
    this.setState({
      dialogOpen: true,
      optionAction: "delete",
    });
  };
  deleteHandler = debounce((key) => {
    const estimateRef = fire.database().ref("estimates").child(key);
    estimateRef.remove();

    this.setState({
      deleteId: key,
      dialogOpen: false,
      page: 1,
    });
    setTimeout(() => {
      this.setState({
        deleteId: "",
      });
    }, 300);
    this.refreshData();
  });
  searchHandler = debounce((value) => {
    this.setState({
      searchKey: value,
    });
  });
  handleCloseEditScreen = () => {
    this.setState({
      typeCast: false,
    });
  };
  render() {
    const dataType = this.props.match.path.includes("estimates")
      ? "estimates"
      : "templates";

    const th = this;
    let listToShow = this.state.arrayItem;
    let favoriteestimates = [];
    for (let i = 0; i < this.state.users.length; i++) {
      if (this.state.users[i]["caption"] === this.state.userEmail) {
        const favoriteestimate = this.state.users[i]["favoriteestimate"];
        favoriteestimates = favoriteestimate;
      }
    }
    // Filters
    if (
      th.state.sort !== "favourites" &&
      this.state.age === "" &&
      this.state.searchKey === ""
    ) {
      listToShow = this.state.arrayItem.sort(function (a, b) {
        if (th.state.sort === "ascending") {
          return a["projectName"].localeCompare(b["projectName"]);
        } else if (th.state.sort === "descending") {
          return b["projectName"].localeCompare(a["projectName"]);
        } else if (th.state.sort === "recent") {
          return b.timestamp - a.timestamp;
        } else {
          return a["id"].toString().localeCompare(b["id"].toString());
        }
      });
    } else if (
      th.state.sort !== "favourites" &&
      this.state.age !== "" &&
      this.state.searchKey === ""
    ) {
      listToShow =
        this.state.arrayItem.sort(function (a, b) {
          if (th.state.sort === "ascending") {
            return a["projectName"].localeCompare(b["projectName"]);
          } else if (th.state.sort === "descending") {
            return b["projectName"].localeCompare(a["projectName"]);
          } else if (th.state.sort === "recent") {
            return b.timestamp - a.timestamp;
          } else {
            return a["id"].toString().localeCompare(b["id"].toString());
          }
        }) &&
        this.state.arrayItem.filter(function (i) {
          return i.filterType.toLowerCase().match(th.state.age.toLowerCase());
        });
    } else if (
      th.state.sort !== "favourites" &&
      this.state.age === "" &&
      this.state.searchKey !== ""
    ) {
      listToShow =
        this.state.arrayItem.sort(function (a, b) {
          if (th.state.sort === "ascending") {
            return a["projectName"].localeCompare(b["projectName"]);
          } else if (th.state.sort === "descending") {
            return b["projectName"].localeCompare(a["projectName"]);
          } else if (th.state.sort === "recent") {
            return b.timestamp - a.timestamp;
          } else {
            return a["id"].toString().localeCompare(b["id"].toString());
          }
        }) &&
        this.state.arrayItem.filter(function (i) {
          const search = th.state.searchKey.toLowerCase().split(" ").join("_");
          const itemName = (i.organization || "") + " " + i.projectName;
          const name = itemName.toLowerCase().split(" ").join("_");
          return name.toLowerCase().match(search);
        });
    } else if (
      th.state.sort !== "favourites" &&
      this.state.age !== "" &&
      this.state.searchKey !== ""
    ) {
      listToShow =
        this.state.arrayItem.sort(function (a, b) {
          if (th.state.sort === "ascending") {
            return a["projectName"].localeCompare(b["projectName"]);
          } else if (th.state.sort === "descending") {
            return b["projectName"].localeCompare(a["projectName"]);
          } else if (th.state.sort === "recent") {
            return b.timestamp - a.timestamp;
          } else {
            return a["id"].toString().localeCompare(b["id"].toString());
          }
        }) &&
        this.state.arrayItem.filter(function (i) {
          const search = th.state.searchKey.toLowerCase().split(" ").join("_");
          const itemName = i.organization ? i.organization : i.projectName;
          const name = itemName.toLowerCase().split(" ").join("_");
          return (
            name.toLowerCase().match(search) &&
            i.filterType.toLowerCase().match(th.state.age.toLowerCase())
          );
        });
    } else if (th.state.sort === "favourites") {
      listToShow = [];
      for (let i = 0; i < favoriteestimates.length; i++) {
        for (let l = 0; l < this.state.arrayItem.length; l++) {
          if (this.state.arrayItem[l] && favoriteestimates[i]) {
            if (favoriteestimates[i]["id"] === this.state.arrayItem[l]["id"]) {
              listToShow.push(this.state.arrayItem[l]);
            }
          }
        }
      }
      if (this.state.age !== "" && this.state.searchKey === "") {
        listToShow = listToShow.filter(function (i) {
          return i.filterType.toLowerCase().match(th.state.age.toLowerCase());
        });
      } else if (this.state.age === "" && this.state.searchKey !== "") {
        listToShow = listToShow.filter(function (i) {
          const search = th.state.searchKey.toLowerCase().split(" ").join("_");
          const itemName = i.organization ? i.organization : i.projectName;
          const name = itemName.toLowerCase().split(" ").join("_");
          return name.toLowerCase().match(search);
        });
      } else if (this.state.age !== "" && this.state.searchKey !== "") {
        listToShow = listToShow.filter(function (i) {
          const search = th.state.searchKey.toLowerCase().split(" ").join("_");
          const itemName = i.organization ? i.organization : i.projectName;
          const name = itemName.toLowerCase().split(" ").join("_");
          return (
            name.toLowerCase().match(search) &&
            i.filterType.toLowerCase().match(th.state.age.toLowerCase())
          );
        });
      }
    }
    const count = Math.ceil(listToShow.length / this.paginationCount);
    listToShow = listToShow.filter(
      (d) => d.archive !== "true" && d.projectName
    );
    return (
      <React.Fragment>
        {this.state.typeCast ? (
          <section
            className="estimated-list"
            style={{ minHeight: "calc(100vh - 60px)" }}
          >
            <EstimateFor
              closeEditScreen={this.handleCloseEditScreen}
              title={
                this.state.typeCast === "true" ? "Time Based" : "Task Based"
              }
              type={this.state.typeCast}
            />
            <SettingsTable
              type={this.state.typeCast}
              update={this.props.update}
            />
          </section>
        ) : (
          <section
            className="all-estimates"
            style={{ minHeight: "calc(100vh - 60px)" }}
          >
            {this.state.loader === true ? (
              <div className="loader-container">
                <object
                  data={loaderimage}
                  type="image/svg+xml"
                  aria-label="loader"
                ></object>
              </div>
            ) : (
              <div className="container">
                <div className="section-intro ">
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{ fontSize: "1.65rem" }}
                  >
                    Manage Estimates
                  </Typography>
                  <Button
                    style={{ marginTop: 7 }}
                    className={this.props.classes.newestimate}
                    onClick={this.overlay}
                  >
                    <span className="icon-outer">
                      <AddCircleOutlineIcon htmlColor="#ffffff" />
                    </span>
                    Create New Estimate{" "}
                  </Button>
                </div>

                <div className="filters">
                  <FilterBox
                    handleChange={this.handleChange}
                    age={this.state.age}
                    handleSort={this.handleSort}
                    classes={this.props.classes}
                    change={this.searchHandler}
                    defaultSearchValue={this.state.defaultSearchValue}
                  />
                </div>
                {listToShow.length > 0 ? (
                  <FilterList
                    items={listToShow}
                    page={this.state.page}
                    classes={this.props.classes}
                    list={this.state.editList}
                    date={true}
                    typecast={this.handlePages}
                    handleFavorite={this.handleFavorite}
                    optionChange={this.optionChange}
                    favoriteestimate={favoriteestimates}
                    dataType={dataType}
                    refreshData={this.refreshData}
                    allTags={this.state.allTags}
                  />
                ) : (
                  <NoItemAddedEstimate
                    content_type="Estimates"
                    Button_type="Estimate"
                    onClick={this.overlay}
                    createNew={this.handleCreate}
                  />
                )}
                <div className={this.props.classes.pagination}>
                  {count > 1 && (
                    <PaginationList
                      count={count}
                      page={this.state.page}
                      handlePageChange={this.handlePageChange}
                    />
                  )}
                </div>
              </div>
            )}
          </section>
        )}
        <AlertDialog
          open={this.state.dialogOpen}
          onClose={this.closeHandler}
          phaseKey={this.state.phaseKey}
          keyValue={this.deleteHandler}
          name={""}
          text={"Do you want to permanently delete this estimates ?"}
        />
      </React.Fragment>
    );
  }
}
export default withRouter(AllEstimates);
